// Тонкая обёртка над Telegram WebApp SDK + хаптика.
type HapticStyle = 'light' | 'medium' | 'heavy' | 'rigid' | 'soft';
type NotifyType = 'success' | 'error' | 'warning';

const wa = () => (window as any).Telegram?.WebApp;

export const telegram = {
  init() {
    const w = wa();
    if (w) {
      w.ready();
      try {
        w.expand?.();
        w.setHeaderColor?.('#0b0d14');
        w.setBackgroundColor?.('#0b0d14');
      } catch {
        /* старые клиенты */
      }
    }
  },
  isInside(): boolean {
    return Boolean(wa()?.initData);
  },
  initData(): string {
    return wa()?.initData || '';
  },
  username(): string | undefined {
    return wa()?.initDataUnsafe?.user?.username;
  },
  startParam(): string | undefined {
    return wa()?.initDataUnsafe?.start_param;
  },
  haptic(style: HapticStyle = 'light') {
    try {
      wa()?.HapticFeedback?.impactOccurred(style);
    } catch {
      /* нет хаптики */
    }
  },
  notify(type: NotifyType) {
    try {
      wa()?.HapticFeedback?.notificationOccurred(type);
    } catch {
      /* нет хаптики */
    }
  },
  // Открыть диалог «поделиться» в Telegram (выбор чата) с текстом и ссылкой.
  share(text: string, url?: string) {
    const link = url || import.meta.env.VITE_APP_SHARE_URL || window.location.origin;
    const shareUrl = `https://t.me/share/url?url=${encodeURIComponent(link)}&text=${encodeURIComponent(text)}`;
    const w = wa();
    if (w?.openTelegramLink) {
      w.openTelegramLink(shareUrl);
    } else {
      window.open(shareUrl, '_blank');
    }
  },
};
